import * as types from './types';


export const sharingMutations = {
  [types.SharingData.SET.ALL] (state, payload) {
    payload.artists.unshift({artist_id:0,artist_name:'All Artists'})
    state.sharingSettingsData = payload;
    // console.log("MUTATION",payload)
  },
  // [types.RssData.SET.SINGLE](state,payload){
  //   if(state.rssData.findIndex(s=>s.artistId==payload.artistId)==-1)
  //   {
  //     state.rssData.push(payload)
  //   }
    
  //   // console.log("MUT",state.rssData)
  // }
 
};